module.exports = __webpack_public_path__ + "static/media/cindrellawilliams.7e5cd9df.PNG";